import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import HRLocaleProvider from './hr/i18n/HRLocaleProvider';
import AnaMenu from './hr/pages/AnaMenu';
import HakkimdaPage from './pages/HakkimdaPage';
import CalismaIlkelerimPage from './pages/CalismaIlkelerimPage';
import HizmetlerimPage from './pages/HizmetlerimPage';
import IletisimPage from './pages/IletisimPage';
import GirisPage from './pages/GirisPage';
import AdayHizmetlerim from './pages/subpages/AdayHizmetlerim';
import IsverenHizmetlerim from './pages/subpages/IsverenHizmetlerim';
import DashboardPage from './pages/DashboardPage';
import ScrollToTop from './helpers/ScrollToTop';
import PromptPage from './pages/PromptPage';
import OnHumanTechPage from './tech/OnHumanTechPage';
import BrandTransitionProvider from './components/BrandTransitionProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HRLocaleProvider>
    <Router>
      <ScrollToTop/>
      <BrandTransitionProvider>
      <Routes>
        <Route path="/" element={<PromptPage />} />
        <Route path="/anamenu" element={<AnaMenu />} />
        <Route path="/hakkimda" element={<HakkimdaPage />} />
        <Route path="/calismailkelerim" element={<CalismaIlkelerimPage />} />
        <Route path="/hizmetlerim" element={<HizmetlerimPage />} />
        <Route path="/iletisim" element={<IletisimPage />} />
        <Route path="/giris" element={<GirisPage />} />
        <Route path="/adayhizmetlerim" element={<AdayHizmetlerim />} />
        <Route path="/isverenhizmetlerim" element={<IsverenHizmetlerim />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/onhumantech" element={<OnHumanTechPage />} />
      </Routes>
      </BrandTransitionProvider>
    </Router>
    </HRLocaleProvider>
  </React.StrictMode>
);

reportWebVitals();
